import {useState} from 'react'
import {Navigate} from 'react-router-dom'
import {logout} from '../lib/allauth'
import Button from '../components/Button'
import * as actions from "../../store/actions";
import {useDispatch} from "react-redux";
import {persistor} from "../../store";

export default function Logout() {
    const [response, setResponse] = useState({fetching: false, content: null})
    const dispatch = useDispatch();

    async function submit() {
        setResponse({...response, fetching: true})
        try {
            // Clear all persisted storage
            persistor.purge();
            
            // Then perform the backend logout
            logout().then((content) => {
                window.location.href = "/"; // hard redirect to home
            }).then(() => {
                setResponse((r) => ({...r, fetching: false}));
            }).catch((e) => {
                console.error(e);
                window.alert(e);
            }).then(() => {
                setResponse((r) => ({...r, fetching: false}));
            })
            
        } catch (e) {
            console.error(e);
            window.alert(e);
        } finally {
            setResponse((r) => ({...r, fetching: false}));
        }
    }

    if (response.content) {
        return <Navigate to='/'/>
    }
    return (
        <>
            <h1>Logout</h1>
            <p>
                Are you sure you want to logout?
            </p>

            <Button disabled={response.fetching} onClick={() => submit()}>Logout</Button>
        </>
    )
}
